import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import WhatsAppFloat from "@/components/layout/WhatsAppFloat";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Principal from "@/pages/Principal";
import Physiotherapy from "@/pages/Physiotherapy";
import Doctor from "@/pages/Doctor";
import Gallery from "@/pages/Gallery";
import Events from "@/pages/Events";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/principal" element={<Principal />} />
          <Route path="/physiotherapy" element={<Physiotherapy />} />
          <Route path="/doctor" element={<Doctor />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/events" element={<Events />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <WhatsAppFloat />
      </BrowserRouter>
    </div>
  );
}

export default App;
